import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const AuthRedirect = () => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role === "tutor") {
    return <Navigate to="/tutor" replace />;
  }

  if (user.role === "student") {
    return <Navigate to="/student" replace />;
  }

  // Safety fallback
  return <Navigate to="/login" replace />;
};

export default AuthRedirect;
